<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md10>
        <v-card title>
          <v-card-title>
            <h2>Usuarios</h2>
          </v-card-title>
          <v-card-text>
            <DataTableMain
              :datatable="table"
              :on-success="successAction"
              :itemsAction="tableAction"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="main" :urls="urls" :message="message"/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
// import AssifnRoleToUserDialog from '@/components/dialogs/AssifnRoleToUserDialog'
// import UsersDialog from '@/components/dialogs/UsuarioDialog'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          {
            title: 'Refrescar',
            icon: 'mdi-cached',
            color: 'primary',
            action: 'refreshData',
            code: 'libre',
            hidden: ''
          },
          {
            title: 'Nuevo',
            icon: 'mdi-plus',
            color: 'success',
            action: 'newData',
            code: '04-0301'
          }
        ],
        titles: [
          { text: 'Usuario', value: 'usuario', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Correo', value: 'correo', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          { text: 'Fecha Actualizada', value: 'Updated' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        losading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-border-color', color: 'yellow darken-2', action: 'toEditData', code: 'config.user-edit' },
          { title: 'asignar role', icon: 'mdi-border-color', color: 'lime lighten-1', action: 'toAssignRole', code: 'config.user-assign-rol' },
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-2', action: 'deleteData', code: 'config.user-delete' }
        ]
      },
      footer: {
        paging: true
      }
    },
    main: {},
    form: [],
    urls: '',
    message: '',
    user: {}
  }),
  components: {
    DataTableMain,
    MainFormDialog
    // UsersDialog, AssifnRoleToUserDialog
  },
  mounted () {
    this.PostListObjects({ url: '/auth/users' })
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['PostListObjects', 'DeleteObject']),

    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.PostListObjects({ url: '/auth/users' })
    },
    newData (item) {
      this.main = {}
      this.form = this.get_UserForm
      this.urls = '/auth/users/store'
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nuevo Usuario' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    toEditData ({ item }) {
      this.main = item
      this.form = this.get_UserUpdateForm
      this.urls = `/auth/users/${item.id}`
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Editar Usuario' })
    },
    toAssignRole ({ item }) {
      let roles = ''
      item.roles.map(item => {
        roles += (roles === '') ? item.nombre : `, ${item.nombre}`
      })
      this.main = { user_id: item.id, correo: item.correo, nombre: item.nombre, usuario: item.usuario, roles: roles }
      this.form = this.get_AsignarRollUserForm
      this.urls = '/auth/users/set-rol'
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', showtype: 'role' })
    },
    deleteData ({ item }) {
      this.$swal.fire({
        title: 'Estas seguro de eliminar el registro?',
        text: 'No podras revertir este movimiento!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!'
      }).then((result) => {
        if (result.value) {
          this.DeleteObject({ url: `/auth/users/${item.id}` })
        }
      })
    },
    ...mapMutations(['SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_objects', 'get_AsignarRollUserForm',
      'get_UserForm', 'get_UserUpdateForm'])
  },
  watch: {
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  }
}
</script>

<style></style>
